export const categories = [
  { slug: 'all', name: '全部', description: '浏览全部韩国漫画' },
  { slug: 'romance', name: '恋爱', description: '浪漫甜美的恋爱韩漫' },
  { slug: 'fantasy', name: '奇幻', description: '充满想象力的奇幻韩漫' },
  { slug: 'action', name: '动作', description: '热血刺激的动作韩漫' },
  { slug: 'drama', name: '剧情', description: '深度剧情韩漫推荐' },
  { slug: 'comedy', name: '搞笑', description: '轻松有趣的搞笑韩漫' },
  { slug: 'thriller', name: '悬疑', description: '紧张刺激的悬疑韩漫' },
  { slug: 'daily', name: '日常', description: '温馨治愈的日常韩漫' },
];

export const comics = [
  {
    id: 1,
    title: '秘密花园',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20illustration%20of%20a%20romance%20story%2C%20two%20young%20characters%20in%20a%20flower%20garden%20setting%2C%20soft%20pastel%20colors%2C%20dreamy%20atmosphere%2C%20anime%20art%20style%2C%20clean%20illustration%20with%20simple%20background%2C%20professional%20manga%20cover%20quality%2C%20warm%20lighting%20with%20cherry%20blossoms%2C%20romantic%20vibe%2C%20delicate%20lineart%2C%20soft%20color%20palette%2C%20whimsical%20and%20charming%20aesthetic&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    author: '金恩淑',
    categories: ['romance', 'drama'],
    description: '一位普通女孩意外进入了一座神秘花园，在那里遇到了改变她一生的男人。两人在花丛中展开了一段唯美而曲折的爱情故事，充满了甜蜜与感动。',
    status: '连载中',
    updateTime: '2026-08-04',
    chapters: 128,
    views: 1528000,
    rating: 9.6,
    featured: true,
    isNew: false,
    chapters_list: [
      { id: 101, comicId: 1, title: '第128话 最后的约定', number: 128, updateTime: '2026-08-04' },
      { id: 100, comicId: 1, title: '第127话 意外的重逢', number: 127, updateTime: '2026-07-28' },
      { id: 99, comicId: 1, title: '第126话 心中的答案', number: 126, updateTime: '2026-07-21' },
      { id: 98, comicId: 1, title: '第125话 不再逃避', number: 125, updateTime: '2026-07-14' },
      { id: 97, comicId: 1, title: '第124话 雨中的告白', number: 124, updateTime: '2026-07-07' },
      { id: 96, comicId: 1, title: '第123话 隐藏的秘密', number: 123, updateTime: '2026-06-30' },
    ],
  },
  {
    id: 2,
    title: '剑与魔法',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20fantasy%20manhwa%20cover%2C%20a%20warrior%20holding%20a%20glowing%20sword%20in%20a%20magical%20forest%2C%20epic%20fantasy%20atmosphere%2C%20dramatic%20lighting%2C%20anime%20art%20style%2C%20clean%20illustration%20with%20simple%20dark%20background%2C%20professional%20manga%20cover%20quality%2C%20mystical%20energy%20effects%2C%20heroic%20stance%2C%20detailed%20armor%20design%2C%20cool%20color%20tones%2C%20adventure%20theme&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    author: '李承焕',
    categories: ['fantasy', 'action'],
    description: '在一个被魔法支配的世界里，年轻的剑士踏上了寻找传说之剑的旅程。与伙伴们一起对抗黑暗势力，在冒险中不断成长。',
    status: '连载中',
    updateTime: '2026-08-03',
    chapters: 96,
    views: 985000,
    rating: 9.4,
    featured: true,
    isNew: false,
    chapters_list: [
      { id: 201, comicId: 2, title: '第96话 光明的希望', number: 96, updateTime: '2026-08-03' },
      { id: 200, comicId: 2, title: '第95话 最后的试炼', number: 95, updateTime: '2026-07-27' },
      { id: 199, comicId: 2, title: '第94话 觉醒的力量', number: 94, updateTime: '2026-07-20' },
      { id: 198, comicId: 2, title: '第93话 魔王的真相', number: 93, updateTime: '2026-07-13' },
      { id: 197, comicId: 2, title: '第92话 同伴的牺牲', number: 92, updateTime: '2026-07-06' },
      { id: 196, comicId: 2, title: '第91话 远古遗迹', number: 91, updateTime: '2026-06-29' },
    ],
  },
  {
    id: 3,
    title: '校园日记',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20school%20life%20manhwa%20cover%2C%20two%20students%20sitting%20on%20a%20rooftop%20overlooking%20the%20city%2C%20warm%20sunset%20lighting%2C%20youthful%20and%20fresh%20atmosphere%2C%20anime%20art%20style%2C%20clean%20illustration%20with%20simple%20sky%20background%2C%20professional%20manga%20cover%20quality%2C%20nostalgic%20vibe%2C%20school%20uniforms%2C%20friendship%20theme%2C%20soft%20warm%20colors%2C%20slice%20of%20life%20aesthetic&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    author: '朴智秀',
    categories: ['daily', 'comedy'],
    description: '高中生活的点点滴滴，友情、梦想与青春的碰撞。一群性格各异的学生在校园中经历的欢乐日常和成长故事。',
    status: '已完结',
    updateTime: '2026-07-15',
    chapters: 80,
    views: 756000,
    rating: 9.2,
    featured: true,
    isNew: false,
    chapters_list: [
      { id: 301, comicId: 3, title: '第80话 毕业那天', number: 80, updateTime: '2026-07-15' },
      { id: 300, comicId: 3, title: '第79话 最后的考试', number: 79, updateTime: '2026-07-08' },
      { id: 299, comicId: 3, title: '第78话 未来的选择', number: 78, updateTime: '2026-07-01' },
      { id: 298, comicId: 3, title: '第77话 学园祭之夜', number: 77, updateTime: '2026-06-24' },
    ],
  },
  {
    id: 4,
    title: '暗夜追踪者',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20thriller%20manhwa%20cover%2C%20a%20detective%20in%20a%20dark%20alley%20with%20mysterious%20shadows%2C%20noir%20atmosphere%2C%20dramatic%20contrast%20lighting%2C%20anime%20art%20style%2C%20clean%20illustration%20with%20dark%20urban%20background%2C%20professional%20manga%20cover%20quality%2C%20suspenseful%20mood%2C%20trench%20coat%20silhouette%2C%20crime%20scene%20vibe%2C%20muted%20colors%20with%20red%20accents%2C%20mysterious%20and%20intense%20aesthetic&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    author: '崔敏浩',
    categories: ['thriller', 'action'],
    description: '一名警探在追踪连环案件的过程中，逐渐发现背后隐藏的巨大阴谋。黑暗中的正义与邪恶较量，每一步都充满危险。',
    status: '连载中',
    updateTime: '2026-08-05',
    chapters: 64,
    views: 1320000,
    rating: 9.7,
    featured: false,
    isNew: true,
    chapters_list: [
      { id: 401, comicId: 4, title: '第64话 真相浮现', number: 64, updateTime: '2026-08-05' },
      { id: 400, comicId: 4, title: '第63话 关键线索', number: 63, updateTime: '2026-07-29' },
      { id: 399, comicId: 4, title: '第62话 暗处的眼睛', number: 62, updateTime: '2026-07-22' },
      { id: 398, comicId: 4, title: '第61话 追捕', number: 61, updateTime: '2026-07-15' },
      { id: 397, comicId: 4, title: '第60话 嫌疑人的身份', number: 60, updateTime: '2026-07-08' },
      { id: 396, comicId: 4, title: '第59话 新的案件', number: 59, updateTime: '2026-07-01' },
    ],
  },
  {
    id: 5,
    title: '仙境咖啡厅',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20slice%20of%20life%20manhwa%20cover%2C%20a%20cozy%20cafe%20with%20warm%20interior%20and%20charming%20characters%2C%20soft%20morning%20light%20streaming%20through%20windows%2C%20anime%20art%20style%2C%20clean%20illustration%20with%20simple%20cafe%20background%2C%20professional%20manga%20cover%20quality%2C%20wholesome%20atmosphere%2C%20coffee%20and%20pastries%2C%20friendly%20vibe%2C%20warm%20brown%20and%20cream%20tones%2C%20comforting%20aesthetic&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    author: '姜素英',
    categories: ['daily', 'romance'],
    description: '隐藏在城市角落的仙境咖啡厅，每一位顾客都有自己的故事。咖啡师与顾客之间温暖人心的相遇与离别。',
    status: '连载中',
    updateTime: '2026-08-02',
    chapters: 45,
    views: 520000,
    rating: 9.3,
    featured: false,
    isNew: true,
    chapters_list: [
      { id: 501, comicId: 5, title: '第45话 新的配方', number: 45, updateTime: '2026-08-02' },
      { id: 500, comicId: 5, title: '第44话 雨天的客人', number: 44, updateTime: '2026-07-26' },
      { id: 499, comicId: 5, title: '第43话 特别的拿铁', number: 43, updateTime: '2026-07-19' },
      { id: 498, comicId: 5, title: '第42话 老友重逢', number: 42, updateTime: '2026-07-12' },
    ],
  },
  {
    id: 6,
    title: '龙之继承者',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20action%20fantasy%20manhwa%20cover%2C%20a%20young%20hero%20with%20dragon%20powers%20in%20an%20ancient%20temple%2C%20epic%20scale%2C%20dramatic%20energy%20effects%2C%20anime%20art%20style%2C%20clean%20illustration%20with%20simple%20temple%20background%2C%20professional%20manga%20cover%20quality%2C%20fiery%20aura%2C%20powerful%20stance%2C%20golden%20and%20crimson%20colors%2C%20legendary%20fantasy%20vibe&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    author: '郑宇镇',
    categories: ['action', 'fantasy'],
    description: '平凡少年意外发现自己拥有龙之血脉，从此踏上成为最强继承者的修炼之路。与各路强敌的战斗，揭开远古龙族的秘密。',
    status: '连载中',
    updateTime: '2026-08-01',
    chapters: 112,
    views: 2100000,
    rating: 9.5,
    featured: true,
    isNew: false,
    chapters_list: [
      { id: 601, comicId: 6, title: '第112话 龙神降临', number: 112, updateTime: '2026-08-01' },
      { id: 600, comicId: 6, title: '第111话 最终决战前夜', number: 111, updateTime: '2026-07-25' },
      { id: 599, comicId: 6, title: '第110话 龙族议会', number: 110, updateTime: '2026-07-18' },
      { id: 598, comicId: 6, title: '第109话 传承之力', number: 109, updateTime: '2026-07-11' },
      { id: 597, comicId: 6, title: '第108话 古老的预言', number: 108, updateTime: '2026-07-04' },
      { id: 596, comicId: 6, title: '第107话 暗黑龙的挑战', number: 107, updateTime: '2026-06-27' },
    ],
  },
  {
    id: 7,
    title: '他的微笑',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20romance%20manhwa%20cover%2C%20a%20gentle%20male%20lead%20smiling%20under%20cherry%20blossom%20trees%2C%20spring%20atmosphere%2C%20soft%20pink%20and%20white%20petals%2C%20anime%20art%20style%2C%20clean%20illustration%20with%20simple%20nature%20background%2C%20professional%20manga%20cover%20quality%2C%20heartwarming%20mood%2C%20delicate%20artwork%2C%20romantic%20spring%20vibe%2C%20gentle%20pastel%20tones&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    author: '尹彩媛',
    categories: ['romance', 'daily'],
    description: '患有社交恐惧症的女主角，在图书馆遇到了总是带着温柔微笑的他。一段治愈心灵的纯爱故事悄然展开。',
    status: '连载中',
    updateTime: '2026-08-03',
    chapters: 56,
    views: 890000,
    rating: 9.4,
    featured: false,
    isNew: false,
    chapters_list: [
      { id: 701, comicId: 7, title: '第56话 勇敢的告白', number: 56, updateTime: '2026-08-03' },
      { id: 700, comicId: 7, title: '第55话 一点点靠近', number: 55, updateTime: '2026-07-27' },
      { id: 699, comicId: 7, title: '第54话 他的秘密', number: 54, updateTime: '2026-07-20' },
      { id: 698, comicId: 7, title: '第53话 图书馆的午后', number: 53, updateTime: '2026-07-13' },
    ],
  },
  {
    id: 8,
    title: '爆笑家族',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20comedy%20manhwa%20cover%2C%20a%20funny%20family%20with%20exaggerated%20expressions%20in%20a%20messy%20living%20room%2C%20chaotic%20and%20lively%20atmosphere%2C%20anime%20art%20style%2C%20clean%20illustration%20with%20simple%20home%20background%2C%20professional%20manga%20cover%20quality%2C%20humorous%20vibe%2C%20bright%20and%20cheerful%20colors%2C%20cartoonish%20expressions%2C%20fun%20family%20theme&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    author: '韩大辉',
    categories: ['comedy', 'daily'],
    description: '一家五口的爆笑日常！老爸爱讲冷笑话，老妈是网购达人，三个孩子各有各的搞怪性格。笑料不断，温暖治愈。',
    status: '连载中',
    updateTime: '2026-08-04',
    chapters: 200,
    views: 3200000,
    rating: 9.1,
    featured: false,
    isNew: false,
    chapters_list: [
      { id: 801, comicId: 8, title: '第200话 家庭旅行大作战', number: 200, updateTime: '2026-08-04' },
      { id: 800, comicId: 8, title: '第199话 老爸的厨艺', number: 199, updateTime: '2026-07-28' },
      { id: 799, comicId: 8, title: '第198话 双十一狂欢', number: 198, updateTime: '2026-07-21' },
      { id: 798, comicId: 8, title: '第197话 宠物大作战', number: 197, updateTime: '2026-07-14' },
    ],
  },
  {
    id: 9,
    title: '末日生存法则',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20post%20apocalyptic%20manhwa%20cover%2C%20survivors%20in%20a%20ruined%20city%20with%20dramatic%20sky%2C%20dark%20and%20intense%20mood%2C%20anime%20art%20style%2C%20clean%20illustration%20with%20ruined%20cityscape%20background%2C%20professional%20manga%20cover%20quality%2C%20survival%20theme%2C%20gritty%20atmosphere%2C%20muted%20earth%20tones%2C%20hope%20amidst%20chaos%2C%20dramatic%20composition&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    author: '张赫宰',
    categories: ['thriller', 'drama'],
    description: '末日降临，文明崩塌。一群幸存者在废墟中挣扎求生，面对资源匮乏、怪物威胁，以及人性最黑暗的一面。',
    status: '连载中',
    updateTime: '2026-07-31',
    chapters: 88,
    views: 1650000,
    rating: 9.6,
    featured: false,
    isNew: false,
    chapters_list: [
      { id: 901, comicId: 9, title: '第88话 安全区的崩塌', number: 88, updateTime: '2026-07-31' },
      { id: 900, comicId: 9, title: '第87话 背叛者', number: 87, updateTime: '2026-07-24' },
      { id: 899, comicId: 9, title: '第86话 最后的物资', number: 86, updateTime: '2026-07-17' },
      { id: 898, comicId: 9, title: '第85话 新发现的避难所', number: 85, updateTime: '2026-07-10' },
    ],
  },
  {
    id: 10,
    title: '星之彼岸',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20sci-fi%20fantasy%20manhwa%20cover%2C%20two%20characters%20looking%20at%20a%20starry%20sky%20with%20galaxies%2C%20dreamy%20and%20beautiful%20cosmic%20atmosphere%2C%20anime%20art%20style%2C%20clean%20illustration%20with%20starry%20space%20background%2C%20professional%20manga%20cover%20quality%2C%20ethereal%20vibe%2C%20deep%20blue%20and%20purple%20cosmic%20colors%2C%20romantic%20sci-fi%20theme%2C%20starlight%20sparkles&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    author: '林艺琳',
    categories: ['fantasy', 'romance'],
    description: '来自不同星球的两人在宇宙的尽头相遇。跨越星际的爱情、冒险与救赎，在浩瀚星辰中谱写动人篇章。',
    status: '连载中',
    updateTime: '2026-08-02',
    chapters: 72,
    views: 780000,
    rating: 9.3,
    featured: false,
    isNew: true,
    chapters_list: [
      { id: 1001, comicId: 10, title: '第72话 星际之门', number: 72, updateTime: '2026-08-02' },
      { id: 1000, comicId: 10, title: '第71话 两个世界的选择', number: 71, updateTime: '2026-07-26' },
      { id: 999, comicId: 10, title: '第70话 母星的呼唤', number: 70, updateTime: '2026-07-19' },
      { id: 998, comicId: 10, title: '第69话 跨越光年的思念', number: 69, updateTime: '2026-07-12' },
    ],
  },
  {
    id: 11,
    title: '武林至尊',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20martial%20arts%20manhwa%20cover%2C%20a%20warrior%20in%20traditional%20martial%20arts%20outfit%20on%20a%20mountain%20peak%2C%20epic%20and%20heroic%2C%20anime%20art%20style%2C%20clean%20illustration%20with%20mountain%20landscape%20background%2C%20professional%20manga%20cover%20quality%2C%20wuxia%20atmosphere%2C%20flowing%20robes%2C%20dramatic%20clouds%2C%20powerful%20aura%2C%20traditional%20eastern%20aesthetic&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    author: '南宫烈',
    categories: ['action', 'drama'],
    description: '出身卑微的少年偶然获得失传武功秘籍，从此踏上武林至尊之路。江湖恩怨、门派斗争，精彩纷呈的武侠世界。',
    status: '连载中',
    updateTime: '2026-08-05',
    chapters: 156,
    views: 2800000,
    rating: 9.8,
    featured: true,
    isNew: false,
    chapters_list: [
      { id: 1101, comicId: 11, title: '第156话 天下第一', number: 156, updateTime: '2026-08-05' },
      { id: 1100, comicId: 11, title: '第155话 最强对决', number: 155, updateTime: '2026-07-29' },
      { id: 1099, comicId: 11, title: '第154话 魔教来袭', number: 154, updateTime: '2026-07-22' },
      { id: 1098, comicId: 11, title: '第153话 剑道巅峰', number: 153, updateTime: '2026-07-15' },
      { id: 1097, comicId: 11, title: '第152话 前辈的遗志', number: 152, updateTime: '2026-07-08' },
      { id: 1096, comicId: 11, title: '第151话 九重天', number: 151, updateTime: '2026-07-01' },
    ],
  },
  {
    id: 12,
    title: '办公室罗曼史',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20office%20romance%20manhwa%20cover%2C%20two%20office%20workers%20sharing%20a%20quiet%20moment%20in%20a%20modern%20office%2C%20professional%20yet%20romantic%20atmosphere%2C%20anime%20art%20style%2C%20clean%20illustration%20with%20office%20interior%20background%2C%20professional%20manga%20cover%20quality%2C%20subtle%20romance%2C%20business%20attire%2C%20warm%20evening%20light%2C%20elegant%20and%20mature%20vibe&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    author: '宋允儿',
    categories: ['romance', 'drama'],
    description: '刚入职场的新人与冷酷上司之间的故事。从互看不顺眼到渐生情愫，办公室里的甜蜜与纠结。成年人的爱情也可以很心动。',
    status: '已完结',
    updateTime: '2026-06-20',
    chapters: 92,
    views: 1850000,
    rating: 9.5,
    featured: false,
    isNew: false,
    chapters_list: [
      { id: 1201, comicId: 12, title: '第92话 最终的答案', number: 92, updateTime: '2026-06-20' },
      { id: 1200, comicId: 12, title: '第91话 勇敢的决定', number: 91, updateTime: '2026-06-13' },
      { id: 1199, comicId: 12, title: '第90话 他的过去', number: 90, updateTime: '2026-06-06' },
      { id: 1198, comicId: 12, title: '第89话 意外的告白', number: 89, updateTime: '2026-05-30' },
    ],
  },
];

export const faqItems = [
  {
    question: '韩漫网的韩国漫画都是免费的吗？',
    answer: '是的，韩漫网提供的所有韩国漫画均为免费在线阅读。我们致力于为漫画爱好者提供高质量的韩漫资源，无需付费即可畅享全部内容。',
  },
  {
    question: '如何在下拉式模式下阅读韩漫？',
    answer: '韩漫网采用专属下拉式阅读模式，您只需在漫画详情页向下滚动即可连续阅读，无需翻页操作。这种模式让韩漫在线阅读更加流畅自然，完美适配手机和电脑端。',
  },
  {
    question: '韩漫网的漫画更新频率如何？',
    answer: '我们的漫画更新团队保持高效运作，热门连载作品通常每周更新一话。您可以关注首页的"最新更新"区域，第一时间获取最新话数。',
  },
  {
    question: '韩漫网支持哪些设备阅读？',
    answer: '韩漫网完美支持电脑、平板和手机端浏览。我们的响应式设计确保在任何设备上都能获得舒适的阅读体验，下拉式模式在移动端尤为便捷。',
  },
  {
    question: '如何找到我想看的韩国漫画？',
    answer: '您可以通过首页的搜索功能查找特定漫画，也可以通过分类页面按类型浏览。我们提供了恋爱、奇幻、动作、剧情等多种分类，方便您快速找到感兴趣的韩漫。',
  },
];